import { getUserConfiguration } from 'owa-session-store';
import { getUserPermissionForFolderId, doesUserHaveActionPermission, } from 'owa-mail-filterable-menu-behavior';
/**
 * This method restricts the movement of the items by drag and drop if user doesn't have enough permission for shared folder
 * @param sourceFolderId - source folder id
 * @param destinationFolderId - destination folder id
 */
export default function isSharedFolderItemMovementPermissible(sourceFolderId, destinationFolderId) {
    var userEmail = getUserConfiguration().SessionSettings.UserEmailAddress;
    var assignedSourceFolderPermission = getUserPermissionForFolderId(sourceFolderId, userEmail);
    var assignedDestinationFolderPermission = getUserPermissionForFolderId(destinationFolderId, userEmail);
    /**
     *  Check write permission for both source and destination folder
     */
    var doesUserHavePermission = doesUserHaveActionPermission(16 /* Move */, assignedSourceFolderPermission) &&
        doesUserHaveActionPermission(16 /* Move */, assignedDestinationFolderPermission);
    return doesUserHavePermission;
}
//# sourceMappingURL=isSharedFolderItemMovementPermissible.js.map